/**
* Copyright by: 

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/
import { Component, Input, OnInit } from '@angular/core';
import {
  getLinkType,
  InputRecordData,
  LinkType
} from '../../../../../../../../models/record/items/input-record.model';

@Component({
  selector: 'input-record',
  templateUrl: './input-record.component.html',
  styleUrls: ['./input-record.component.scss'],
  standalone: false
})
export class InputRecordComponent implements OnInit {
  @Input() record!: InputRecordData;
  linkType?: LinkType;

  constructor() {}

  ngOnInit(): void {
    this.linkType = getLinkType(this.record.inputType);
  }
}
